import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from 'src/app/app.reducer';
import { IItineraryHistory } from 'src/app/core/models/itinerary-history.model';
import { Operation } from 'src/app/core/models/operation-log.model';
import { StepResult } from 'src/app/core/models/Step-Result.model';
import { OperationLogActions } from '../actions';
import * as fromReducer from '../reducers/pnr.reducer';

@Injectable()
export class OperationLogService {
  constructor(private store: Store<State>) {}

  getOperations(): Observable<Operation[]> {
    return this.store.pipe(select(fromReducer.getOperations));
  }

  getPNRHistory(): Observable<string> {
    return this.store.pipe(select(fromReducer.getPNRHistory));
  }

  getAirCompanyNotes(): Observable<string> {
    return this.store.pipe(select(fromReducer.getAirCompanyNotes));
  }

  getPNRItineraryHistory(): Observable<StepResult[]> {
    return this.store.pipe(select(fromReducer.getPNRItineraryHistory));
  }

  dispatchLoadOperationsSuccess(operations: Operation[]) {
    this.store.dispatch(OperationLogActions.LoadOperationsSuccess({ operations }));
  }

  dispatchLoadHistorySuccess(history: string) {
    this.store.dispatch(OperationLogActions.LoadPNRHistorySuccess({ history }));
  }

  dispatchLoadAirCompanyNotesSuccess(airCompanyNotes: string) {
    this.store.dispatch(OperationLogActions.LoadAirCompanyNotesSuccess({ airCompanyNotes }));
  }

  dispatchLoadItineraryHistorySuccess(itineraryHistory: StepResult[]) {
    this.store.dispatch(OperationLogActions.LoadPNRItineraryHistorySuccess({ itineraryHistory }));
  }
}
